import React from "react";
import Gallery from "react-image-gallery";

import "react-image-gallery/styles/css/image-gallery.css";
import "./ImageGallery.css";

const isVideo = (src) =>
  typeof src === "string" && /\.(mp4|webm|ogg)$/i.test(src);

const RenderVideo = (url) => {
  return (
    <div>
      <iframe
        width="100%"
        height="600"
        src={url}
        title="Video"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    </div>
  );
};

const RenderLocalVideo = (src) => {
  return (
    <div className="video-wrapper">
      <video
        width="100%"
        height="600"
        controls
        playsInline
        style={{ objectFit: "contain", background: "#000" }}
      >
        <source src={src} type="video/mp4" />
      </video>
    </div>
  );
};

const ImageGallery = (props) => {
  const imageList = props?.images?.map((image) => {
    if (isVideo(image)) {
      return {
        original: image,
        thumbnail: image,
        renderItem: () => RenderLocalVideo(image),
      };
    }

    return {
      original: image,
      thumbnail: image,
      ...(image?.includes?.("http")
        ? { embedUrl: image, renderItem: () => RenderVideo(image) }
        : {}),
    };
  });

  return (
    <div>
      <Gallery items={imageList} showBullets showThumbnails={false} />
    </div>
  );
};

export default ImageGallery;
